module.exports = __webpack_public_path__ + "static/media/Empanelment-one.788d9db0.png";